import axios from 'axios';
import { configs } from '../../assets/Config';

export function getCalequityData(token) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'get',
                url: `${process.env.REACT_APP_BASEURL}/admin/calequity`,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            let res = await axios(config)
            if (res.status === 200) {
                let temp = []
                res.data.data.forEach(element => {
                    temp.push(element.data)
                });
                resolve(temp && temp.length > 0 ? { data: temp } : {
                    data: [{
                        company_id: '',
                        data: {
                            risk: '',
                            lastPrice: '',
                            highlight: '',
                            description: ''
                        }
                    }]
                })
            } else {
                resolve(res)
            }
        } catch (err) {
            resolve(err?.response)
        }
    })
}

export function postCalequityData(token, value) {
    return new Promise(async (resolve, reject) => {
        try {
            var config = {
                method: 'post',
                url: `${process.env.REACT_APP_BASEURL}/admin/calequity/save`,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    data: value
                })
            };

            let res = await axios(config)
            resolve(res)
        } catch (err) {
            resolve(err?.response)
        }
    })
}


